import { render, staticRenderFns } from "./fvInputbox.vue?vue&type=template&id=190a7b91&lang=pug&"
import script from "./fvInputbox.vue?vue&type=script&lang=js&"
export * from "./fvInputbox.vue?vue&type=script&lang=js&"
import style0 from "./fvInputbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvInputbox.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvInputbox.vue
// module id = 131
// module chunks = 0 1